export const blockIconsUiactionsArrowBackNew = (
	<span className='material-symbols-outlined'>arrow_back</span>
);
